import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-admin',
  templateUrl: './home-admin.component.html',
  styles: []
})
export class HomeAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
